import React, { useState } from 'react';
import { format } from 'date-fns';
import { el } from 'date-fns/locale';
import { CalendarDays } from 'lucide-react';
import { Popover, PopoverTrigger, PopoverContent } from './ui/popover';
import { Calendar } from './ui/calendar';

export const DateField = ({ value, onChange, className = '', testId, placeholder = 'ηη/μμ/έτος' }) => {
  const [open, setOpen] = useState(false);
  const date = value ? new Date(`${value}T12:00:00`) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className={`inline-flex items-center gap-2 h-9 px-3 rounded-lg border border-stone-300 bg-white text-sm font-medium text-slate-900 hover:bg-stone-50 transition-colors whitespace-nowrap ${className}`}
        >
          <CalendarDays className="w-4 h-4 text-slate-500 shrink-0" />
          {date ? format(date, 'dd/MM/yyyy') : placeholder}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-1.5" align="start">
        <Calendar
          mode="single"
          locale={el}
          selected={date}
          defaultMonth={date}
          onSelect={(d) => {
            if (d) {
              onChange(format(d, 'yyyy-MM-dd'));
              setOpen(false);
            }
          }}
          classNames={{
            day_selected: 'bg-red-700 text-white hover:bg-red-700 hover:text-white focus:bg-red-700 focus:text-white',
            day_today: 'bg-amber-100 text-slate-900',
          }}
        />
      </PopoverContent>
    </Popover>
  );
};

export default DateField;
